import { useStaticCallback } from '@sparemin/blockhead';
import { useEffect } from 'react';
import { EDDY_TRUSTED_ORIGINS } from '../constants';

export type UseMessageHandlerProps = {
  iframe?: HTMLIFrameElement | null;
};

export default function useMessageHandler<T>(
  handler: (message: MessageEvent<T>) => void,
  props?: UseMessageHandlerProps,
) {
  const { iframe } = props || {};

  const callback = useStaticCallback(handler);

  useEffect(() => {
    const handleMessage = (e: MessageEvent<T>) => {
      if (EDDY_TRUSTED_ORIGINS.includes(e.origin)) {
        // If we have a specific iframe, only process messages from that iframe.
        if (iframe && e.source !== iframe.contentWindow) {
          return;
        }

        callback(e);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [callback, iframe]);
}
